// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3z5Vq","colMaxWidth":"Table_colMaxWidth__1TdjV"};